import { createActions, createReducer } from 'reduxsauce';
import utils from '../../../core/utils';

// Define Action
const { Types, Creators } = createActions({
  getTodayPlanId: ['classroomId'],
  getTodayPlanIdSuccess: null,
  getTeachDocs: ['planId'],
  getTeachDocsSuccess: null,
  getActivityList: ['planId', 'classroomId'],
  getActivityListSuccess: null,
  getPublishedCount: ['lessonId'],
  getPublishedCountSuccess: null,
  getPublishedDocs: ['lessonId'],
  getPublishedDocsSuccess: null,
  getPublishedActivitys: ['lessonId', 'classroomId'],
  getPublishedActivitysSuccess: null,
  getPaperList: ['data'],
  getPaperListSuccess: null,
  getUnpublishActivityList: ['data'],
  getUnpublishActivityListSuccess: null,
  getQuestionnaireList: ['data'],
  getQuestionnaireListSuccess: null,
  getDiscussionList: ['data'],
  getDiscussionListSuccess: null,
  getAnnouncementList: ['data'],
  getAnnouncementListSuccess: null,
  getQuestionnaireFromBank: ['data'],
  getQuestionnaireFromBankSuccess: null,
  resetActivityListPagination: null,
  publishResource: [
    'lessonId',
    'resourceType',
    'resourceId',
    'resourceContentId',
    'planId',
    'resourceRelId',
  ],
  publishResourceSuccess: null,
  publishQuestionaire: [
    'questionaireId',
    'classroomId',
    'lessonId',
    'originalResourceId',
  ],
  publishQuestionaireSuccess: null,
  publishQuestionaireFromBank: ['data'],
  publishQuestionaireFromBankSuccess: null,
  publishExercise: ['exerciseId', 'classroomId', 'lessonId'],
  publishExerciseSuccess: null,
  publishExerciseNew: ['examId', 'fromExamId'],
  publishExerciseNewSuccess: null,
  publishPost: ['postId', 'lessonId'],
  publishPostSuccess: null,
  publishAnnouncement: ['announceId', 'lessonId'],
  publishAnnouncementSuccess: null,
  setPublishStatusDefault: ['resourceId'],
  setPublishStatusDefaultSuccess: null,
  getOnlineCourseInfo: ['classroomId'],
  getOnlineCourseInfoSuccess: null,
  addTeachDocs: ['query'],
  addTeachDocsSuccess: null,
  startCheckin: ['time', 'wsLessonId', 'wsClassroomId', 'signType', 'planId'],
  startCheckinSuccess: null,
  restoreChecinStatus: null,
  getClassroomLessonInfo: ['classroomId'],
  getClassroomLessonInfoSuccess: ['data'],
  closeLesson: ['classroomId', 'lessonId'],
  closeLessonSuccess: null,
  closeLessonDirect: ['closeLessonResult'],
  resetCloseRedux: null,
  toggleToolArea: ['showToolArea'],
  publishTeachDocFromBank: ['lessonId', 'resourceId'],
  publishTeachDocFromBankSuccess: null,
  getTeachDocsFromBank: ['data'],
  getTeachDocsFromBankSuccess: null,
  addExamFromBank: ['examIds', 'planId', 'classroomId'],
  addExamFromBankSuccess: null,
  listHistoryActivity: ['classroomId'],
  listHistoryActivitySuccess: null,
  saveMocTermPdfResource: ['data'],
  saveMocTermPdfResourceSuccess: ['resource'],
});

export const Creator = Creators;
export const Type = Types;

// Define Initial State
const INITIAL_STATE = {
  planId: '',
  docList: [],
  activityList: [],
  publishedCount: 0,
  publishedDocs: [],
  publishedActivitys: {
    paperList: [],
    postList: [],
    questionnaireList: [],
    announceList: [],
    papers: [], // 新版练习
  },
  newPublishedActivityDto: {},
  paperList: null, // 练习列表
  unPublishActivityList: null, // 未发布练习列表
  questionnaireList: null, // 问卷列表
  discussionList: null, // 讨论列表
  announcementList: null, // 公告列表
  activityListPagination: null, // 活动列表分页
  publishDocSuccess: false,
  publishActivitySuccess: false,
  onlineCourseInfo: {},
  addTeachDocsResultId: null,
  checkinSuccess: false,
  hasCheckin: false,
  addTeachDocsResultObj: null,
  closeLessonResult: false,
  showToolArea: true, // 是否显示工具区域
  signinId: null,
  teachDocsFromBank: null, // 教案库教案列表
  teachDoscPagination: null, // 翻页信息
  examDocsFromBank: null,
  publishedResourceId: null,
  publishedResourceContentId: null,
  savedMocTermPdfResource: null,
};

const formateActivity = (activity, sort = 1) => {
  const result = utils.activity.sortActivity(activity, sort);
  return result;
};
// Define Reducer
export default createReducer(INITIAL_STATE, {
  [Types.GET_TODAY_PLAN_ID_SUCCESS]: (state = INITIAL_STATE, action) => ({
    ...state,
    planId: action.planId,
  }),
  [Types.GET_TEACH_DOCS_SUCCESS]: (state = INITIAL_STATE, action) => ({
    ...state,
    docList: action.docList,
  }),
  [Types.GET_ACTIVITY_LIST_SUCCESS]: (state = INITIAL_STATE, action) => ({
    ...state,
    activityList: formateActivity(action.activityList),
  }),
  [Types.GET_PUBLISHED_COUNT_SUCCESS]: (state = INITIAL_STATE, action) => ({
    ...state,
    publishedCount: action.publishedCount,
  }),
  [Types.GET_PUBLISHED_DOCS_SUCCESS]: (state = INITIAL_STATE, action) => ({
    ...state,
    publishedDocs: action.publishedDocs,
  }),
  [Types.GET_PUBLISHED_ACTIVITYS_SUCCESS]: (state = INITIAL_STATE, action) => ({
    ...state,
    publishedActivitys: formateActivity(action.publishedActivitys, 2),
  }),
  [Types.LIST_HISTORY_ACTIVITY_SUCCESS]: (state = INITIAL_STATE, action) => ({
    ...state,
    newPublishedActivityDto: action.newPublishedActivityDto?.list ?? [],
  }),
  [Types.GET_PAPER_LIST_SUCCESS]: (state = INITIAL_STATE, action) => ({
    ...state,
    activityListPagination: action.query,
    paperList: action.res,
  }),
  [Types.GET_QUESTIONNAIRE_FROM_BANK_SUCCESS]: (
    state = INITIAL_STATE,
    action,
  ) => ({
    ...state,
    activityListPagination: action.query,
    questionnaireList: action.res,
  }),
  [Types.GET_UNPUBLISH_ACTIVITY_LIST_SUCCESS]: (
    state = INITIAL_STATE,
    action,
  ) => ({
    ...state,
    activityListPagination: action.query,
    unPublishActivityList: action.res,
  }),
  [Types.GET_QUESTIONNAIRE_LIST_SUCCESS]: (state = INITIAL_STATE, action) => ({
    ...state,
    activityListPagination: action.query,
    questionnaireList: action.res,
  }),
  [Types.GET_DISCUSSION_LIST_SUCCESS]: (state = INITIAL_STATE, action) => ({
    ...state,
    activityListPagination: action.query,
    discussionList: action.res,
  }),
  [Types.GET_ANNOUNCEMENT_LIST_SUCCESS]: (state = INITIAL_STATE, action) => ({
    ...state,
    activityListPagination: action.query,
    announcementList: action.res,
  }),
  [Types.RESET_ACTIVITY_LIST_PAGINATION]: (state = INITIAL_STATE, action) => ({
    ...state,
    activityListPagination: null,
  }),

  [Types.PUBLISH_RESOURCE_SUCCESS]: (state = INITIAL_STATE, action) => {
    return {
      ...state,
      publishDocSuccess: action.publishDocSuccess,
      [`resource_${action.resResourceId}`]: true,
      publishedResourceId: action.resResourceId,
      publishedResourceContentId: action.resResourceContentId,
    };
  },
  [Types.SET_PUBLISH_STATUS_DEFAULT]: (state = INITIAL_STATE, action) => ({
    ...state,
    [`resource_${action.resourceId}`]: false,
  }),
  [Types.PUBLISH_QUESTIONAIRE_SUCCESS]: (state = INITIAL_STATE, action) => ({
    ...state,
    publishActivitySuccess: action.publishActivitySuccess,
    [`resource_${action.resResourceId}`]: true,
    [`resource_${action.originalResourceId}`]: true,
    publishedResourceId: action.resResourceId,
  }),
  [Types.PUBLISH_EXERCISE_SUCCESS]: (state = INITIAL_STATE, action) => ({
    ...state,
    publishActivitySuccess: action.publishActivitySuccess,
    [`resource_${action.resResourceId}`]: true,
  }),
  [Types.PUBLISH_EXERCISE_NEW_SUCCESS]: (state = INITIAL_STATE, action) => ({
    ...state,
    publishActivitySuccess: action.publishActivitySuccess,
    [`resource_${action.resResourceId}`]: true,
    publishedResourceId: action?.publishedResourceId,
  }),
  [Types.PUBLISH_POST_SUCCESS]: (state = INITIAL_STATE, action) => ({
    ...state,
    publishActivitySuccess: action.publishActivitySuccess,
    [`resource_${action.resResourceId}`]: true,
  }),
  [Types.PUBLISH_ANNOUNCEMENT_SUCCESS]: (state = INITIAL_STATE, action) => ({
    ...state,
    publishActivitySuccess: action.publishActivitySuccess,
    [`resource_${action.resResourceId}`]: true,
  }),
  [Types.GET_ONLINE_COURSE_INFO_SUCCESS]: (state = INITIAL_STATE, action) => ({
    ...state,
    onlineCourseInfo: action.onlineCourseInfo || {},
  }),
  [Types.ADD_TEACH_DOCS_SUCCESS]: (state = INITIAL_STATE, action) => ({
    ...state,
    addTeachDocsResultObj: action.res,
  }),
  [Types.CLOSE_LESSON_SUCCESS]: (state = INITIAL_STATE, action) => ({
    ...state,
    closeLessonResult: action.closeLessonResult,
  }),
  [Types.CLOSE_LESSON_DIRECT]: (state = INITIAL_STATE, action) => ({
    ...state,
    closeLessonResult: action.closeLessonResult,
  }),
  [Types.RESET_CLOSE_REDUX]: (state = INITIAL_STATE, action) => ({
    ...state,
    closeLessonResult: false,
  }),
  [Types.START_CHECKIN_SUCCESS]: (state = INITIAL_STATE, action) => ({
    ...state,
    checkinSuccess: true,
  }),
  [Types.RESTORE_CHECIN_STATUS]: (state = INITIAL_STATE, action) => ({
    ...state,
    checkinSuccess: false,
  }),
  [Types.GET_CLASSROOM_LESSON_INFO_SUCCESS]: (
    state = INITIAL_STATE,
    action,
  ) => {
    const filterData = action.data.recordDetailDtos?.filter(
      item => item.signClosedTime > action.data.serverTime,
    );
    const signinId = filterData && (filterData[0]?.signinId ?? null);
    return {
      ...state,
      hasCheckin: filterData?.length ?? -1 > 0,
      signinId,
    };
  },

  [Types.TOGGLE_TOOL_AREA]: (state = INITIAL_STATE, action) => {
    return {
      ...state,
      showToolArea: action.showToolArea,
    };
  },
  [Types.PUBLISH_TEACH_DOC_FROM_BANK_SUCCESS]: (
    state = INITIAL_STATE,
    action,
  ) => {
    return {
      ...state,
      publishDocFromBankSuccess: action.publishDocFromBankSuccess,
      [`resource_${action.resResourceId}`]: true,
      publishedResourceId: action.resResourceId,
    };
  },
  [Types.GET_TEACH_DOCS_FROM_BANK_SUCCESS]: (state = INITIAL_STATE, action) => {
    return {
      ...state,
      teachDoscPagination: action.query,
      teachDocsFromBank: action.res,
    };
  },
  [Types.SAVE_MOC_TERM_PDF_RESOURCE_SUCCESS]: (
    state = INITIAL_STATE,
    action,
  ) => {
    return {
      ...state,
      savedMocTermPdfResource: action.resource,
    };
  },
  [Types.ADD_EXAM_FROM_BANK_SUCCESS]: (state = INITIAL_STATE, action) => {
    return {
      ...state,
      examDocsFromBank: action.res,
    };
  },
});
